import axios from 'axios'
import SessionStorage from 'sessionstorage';
import {APIHOST, MOMENT_API_DATE_FORMAT} from "@/settings";
import _ from "underscore";
import {jsonDataToExcel} from "@/js/XLSX";
import PrintJs from "print-js";
import moment from "moment";
import mappers from "../helpers/mappers";

class ReturnOrderService {
    register(data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.post(`${APIHOST}/api/RegisterReturnOrder`, data, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        })
    }

    edit(id, data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.put(`${APIHOST}/api/RegisterReturnOrder`, data, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            },
            params: {
                id: id
            }
        })
    }

    getInfo(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ReturnOrderInfo/${id}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    getAllbox({
                  sortBy,
                  sortDesc,
                  skip,
                  limit,
                  search,
                  branch,
                  isExecutorApproved,
                  isCustomerApproved,
                  statuses
              }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ReturnOrderAllbox`, {
            params: {
                sortBy: sortBy,
                desc: sortDesc,
                skip: skip,
                limit: limit,
                q: search,
                branch: branch ? branch : null,
                isExecutorApproved: isExecutorApproved,
                isCustomerApproved: isCustomerApproved,
                statuses:statuses
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    printPdf(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        const promise = axios.get(`${APIHOST}/api/ReturnOrderPdf`, {
            responseType: 'blob',
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            },
            params: {id: id}
        });

        promise.then(response => {
            const blob = new Blob([response.data]);
            const url = window.URL.createObjectURL(blob);

            PrintJs(url);
        });

        return promise;
    }

    getProcessingbox({
                         sortBy,
                         sortDesc,
                         skip,
                         limit,
                         search,
                         startReturnDate,
                         endReturnDate,
                         branch,
                         isExecutorApproved,
                         isCustomerApproved
                     }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ReturnOrderProcessingbox`, {
            params: {
                sortBy: sortBy,
                desc: sortDesc,
                skip: skip,
                limit: limit,
                q: search,
                startReturnDate: startReturnDate ? startReturnDate.format(MOMENT_API_DATE_FORMAT) : null,
                endReturnDate: endReturnDate ? endReturnDate.format(MOMENT_API_DATE_FORMAT) : null,
                branch: branch ? branch : null,
                isExecutorApproved: isExecutorApproved,
                isCustomerApproved: isCustomerApproved,
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getCompletebox({
                       sortBy,
                       sortDesc,
                       skip,
                       limit,
                       search,
                       startReturnDate,
                       endReturnDate,
                       branch,
                       isExecutorApproved,
                       isCustomerApproved
                   }) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ReturnOrderCompletebox`, {
            params: {
                sortBy: sortBy,
                desc: sortDesc,
                skip: skip,
                limit: limit,
                q: search,
                startReturnDate: startReturnDate ? startReturnDate.format(MOMENT_API_DATE_FORMAT) : null,
                endReturnDate: endReturnDate ? endReturnDate.format(MOMENT_API_DATE_FORMAT) : null,
                branch: branch ? branch : null,
                isExecutorApproved: isExecutorApproved,
                isCustomerApproved: isCustomerApproved,
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    downloadExcelSingle(id) {
        return new Promise((resolve, reject) => {
            this.getInfo(id)
                .then(response => {
                    let order = {
                        id: response.data.Id,
                        executorEditStrategyCode: response.data.ExecutorEditStrategy,
                        shipmentDeliveryDateStrategyCode: response.data.ShipmentDeliveryDateStrategy,
                        executorCreateInvoiceStrategy: response.data.ExecutorCreateInvoiceStrategy,

                        customer: {
                            inn: response.data.CustomerInn,
                            name: response.data.CustomerName
                        },
                        supplier: {
                            inn: response.data.ExecutorInn,
                            name: response.data.ExecutorName
                        },

                        number: response.data.Number,
                        date: moment(response.data.Date),

                        contractNumber: response.data.ContractNumber,
                        contractDate: moment(response.data.ContractDate),

                        expiresOn: moment(response.data.ExpiresOn),
                        deliveryAddress: response.data.DeliveryAddress,
                        createdOn: moment(response.data.CreatedOn),

                        isCustomerApproved: response.data.IsCustomerApproved,
                        customerApprovedOn: response.data.CustomerApprovedOn ? moment(response.data.CustomerApprovedOn) : null,

                        isSupplierApproved: response.data.IsExecutorApproved,
                        supplierApprovedOn: response.data.ExecutorApprovedOn ? moment(response.data.ExecutorApprovedOn) : null,

                        isSupplierDeclined: response.data.IsExecutorDeclined,
                        supplierDeclinedOn: response.data.ExecutorDeclinedOn ? moment(response.data.ExecutorDeclinedOn) : null,

                        returnNumber: response.data.ReturnNumber,
                        returnDate: response.data.ReturnDate ? moment(response.data.ReturnDate) : null,

                        returnInvoiceId: response.data.ReturnInvoiceId,
                        returnInvoiceNumber: response.data.ReturnInvoiceNumber,
                        returnInvoiceDate: response.data.ReturnInvoiceDate ? moment(response.data.ReturnInvoiceDate) : null,

                        isReturnInvoiceExecutorApproved: response.data.IsReturnInvoiceExecutorApproved,
                        isReturnInvoiceCustomerApproved: response.data.IsReturnInvoiceCustomerApproved,

                        items: _.map(response.data.Items, i => {
                            return {
                                id: i.Id,
                                product: i.Product,
                                measurement: i.Measurement,
                                quantity: i.Quantity,
                                price: i.Price,
                                total: i.Total,
                                ndsRate: i.NdsRate,
                                ndsValue: i.NdsValue,
                                totalWithNds: i.TotalWithNds
                            };
                        })
                    };

                    let itemsExcel = _.map(order.items, function (item) {
                        return {
                            'Id заказа': order.id,

                            'Номер заказа': order.number,
                            'Дата заказа': order.date ? order.date.format('YYYY-MM-DD') : '',

                            'Номер договора': order.contractNumber,
                            'Дата договора': order.contractDate ? order.contractDate.format('YYYY-MM-DD') : '',

                            'Заказчик': order.customer.name,
                            'Инн заказчика': order.customer.inn,

                            'Поставщик': order.supplier.name,
                            'Инн поставщика': order.supplier.inn,

                            'Адрес доставки': order.deliveryAddress,

                            'Одобрен заказчиком': order.isCustomerApproved ? 'Да' : 'Нет',
                            'Дата одобрения': order.customerApprovedOn ? order.customerApprovedOn.format('YYYY-MM-DD HH:mm') : '',

                            'Одобрен поставщиком': order.isSupplierApproved ? 'Да' : 'Нет',
                            'Дата одобрения поставщиком': order.supplierApprovedOn ? order.supplierApprovedOn.format('YYYY-MM-DD HH:mm') : '',

                            'Поставщик отклонен': order.isSupplierDeclined ? 'Да' : 'Нет',
                            'Дата отклонения': order.supplierDeclinedOn ? order.supplierDeclinedOn.format('YYYY-MM-DD HH:mm') : '',

                            'Номер возврата': order.returnNumber,
                            'Дата возврата': order.returnDate ? order.returnDate.format('YYYY-MM-DD') : '',

                            'Номер возвратная счёт-фактура': order.returnInvoiceNumber,
                            'Дата возвратная счёт-фактура': order.returnInvoiceDate ? order.returnInvoiceDate.format('YYYY-MM-DD') : '',

                            'Одобрен возврат заказчиком': order.isReturnInvoiceExecutorApproved ? 'Да' : 'Нет',
                            'Одобрен возрат поставщиком': order.isReturnInvoiceCustomerApproved ? 'Да' : 'Нет',

                            'Создано': order.createdOn ? order.createdOn.format('YYYY-MM-DD HH:mm') : '',

                            'Товар': item.product,
                            'Ед. изм.': item.measurement,
                            'Кол-во': item.quantity,
                            'Цена за единицу': item.price,
                            'Стоимость': item.total,
                            'Ставка НДС в %': item.ndsRate,
                            'Сумма НДС': item.ndsValue,
                            'Стоимость с учётом НДС': item.totalWithNds,
                        }
                    });
                    jsonDataToExcel(itemsExcel);

                    resolve()
                }, reject)
        })
    }

    downloadExcelAll(loadOrdersMethod, params, onEachReturnOrderInfoComplete) {
        return new Promise((resolve, reject) => {
            loadOrdersMethod(params)
                .then(response => {
                    let returnOrder = _.map(response.data.Records, returnOrderViewModel => {
                        if (typeof onEachReturnOrderInfoComplete === "function")
                            onEachReturnOrderInfoComplete()
                        return mappers.mapOrder(returnOrderViewModel)
                    })
                    let excelData = []
                    _.each(returnOrder, order => {
                        let orderMetaRow = {}
                        orderMetaRow = {
                            'Номер накладной': order.returnNumber,
                            'Дата накладной': order.returnDate ? order.returnDate.format('DD.MM.YYYY') : '',

                            'Номер заказа': order.number,
                            'Дата заказа': order.date ? order.date.format('DD.MM.YYYY') : '',

                            'Номер договора': order.contractNumber,
                            'Дата договора': order.contractDate ? order.contractDate.format('DD.MM.YYYY') : '',

                            'Поставщик': order.executorName,
                            'Заказчик': order.customerName,
                            'Адрес доставки':order.deliveryAddress,
                            'Подтверждён поставщиком':order.isExecutorApproved ? 'Да' : 'Нет',
                            'Подтверждён заказчиком':order.isCustomerApproved ? 'Да' : 'Нет',
                            'Приостановлен поставщиком':order.isStopped ? 'Да' : 'Нет',
                            'Отказано поставщиком':order.isExecutorDeclined ? 'Да' : 'Нет',

                            'Дата создания': order.createdOn ? order.createdOn.format('DD.MM.YYYY HH:mm') : '',
                        }
                        excelData.push(orderMetaRow)
                    });

                    jsonDataToExcel(excelData, "Все заказы на возврат.xlsx");

                    resolve()
                }, reject)
        })
    }

    downloadExcellAllWithItems(loadOrdersMethod, params, onEachReturnOrderInfoComplete) {
        loadOrdersMethod(params)
            .then(response => {
                let returnOrder = _.map(response.data.Records, returnOrderViewModel => {

                    return mappers.mapOrder(returnOrderViewModel)
                })
                const loadReturnOrderPromises = []
                _.each(returnOrder, order => {
                    loadReturnOrderPromises.push(this.getInfo(order.id).finally(() => {
                        if (typeof onEachReturnOrderInfoComplete === "function")
                            onEachReturnOrderInfoComplete()
                    }))
                })
                Promise.all(loadReturnOrderPromises).then(returnOrderResults => {

                    const column1 = 'Номер накладной'
                    const column2 = 'Дата накладной'
                    const column3 = 'Номер заказа'
                    const column4 = 'Дата заказа'
                    const column5 = 'Номер договора'
                    const column6 = 'Дата договора'
                    const column7 = 'Поставщик'
                    const column8 = 'Заказчик'
                    const column9 = 'Адрес доставки'
                    const column10 = 'Подтверждён поставщиком'
                    const column11 = 'Подтверждён заказчиком'
                    const column12 = 'Приостановлен поставщиком'
                    const column13 = 'Отказано поставщиком'

                    const column14 = 'Дата создания'
                    const column15 = '№'
                    const column16 = 'Товар'
                    const column17 = 'Ед.изм'
                    const column18 = 'Количество'
                    const column19 = 'Цена за единицу'
                    const column20 = 'Стоимость'
                    const column21 = 'НДС ставка'
                    const column22 = 'НДС сумма'
                    const column23 = 'Сумма с НДС'


                    let excelData = []
                    _.each(returnOrderResults, returnOrderResult => {
                        const returnOrderInfo = mappers.mapOrderInfo(returnOrderResult.data)
                        let index = 0;
                        _.each(returnOrderInfo.items, item => {
                            let orderMetaRow = {}

                            orderMetaRow[column1] = returnOrderInfo.returnNumber
                            orderMetaRow[column2] = returnOrderInfo.returnDate.format('DD.MM.YYYY')
                            orderMetaRow[column3] = returnOrderInfo.number
                            orderMetaRow[column4] = returnOrderInfo.date.format('DD.MM.YYYY');
                            orderMetaRow[column5] = returnOrderInfo.contractNumber;
                            orderMetaRow[column6] = returnOrderInfo.contractDate.format('DD.MM.YYYY')

                            orderMetaRow[column7] = returnOrderInfo.executorName
                            orderMetaRow[column8] = returnOrderInfo.customerName
                            orderMetaRow[column9] = returnOrderInfo.deliveryAddress
                            orderMetaRow[column10] = returnOrderInfo.isExecutorApproved ? 'Да' : 'Нет'
                            orderMetaRow[column11] = returnOrderInfo.isCustomerApproved ? 'Да' : 'Нет'
                            orderMetaRow[column12] = returnOrderInfo.isStopped ? 'Да' : 'Нет'
                            orderMetaRow[column13] = returnOrderInfo.isExecutorDeclined ? 'Да' : 'Нет'
                            orderMetaRow[column14] = returnOrderInfo.createdOn.format('DD.MM.YYYY HH:mm:ss')
                            orderMetaRow[column15] = `${index + 1}`
                            orderMetaRow[column16] = item.product
                            orderMetaRow[column17] = item.measurement
                            orderMetaRow[column18] = item.quantity
                            orderMetaRow[column19] = item.price
                            orderMetaRow[column20] = item.total
                            orderMetaRow[column21] = item.ndsRate
                            orderMetaRow[column22] = item.ndsValue
                            orderMetaRow[column23] = item.totalWithNds 
                            index++
                            excelData.push(orderMetaRow)
                        })
                    })
                    jsonDataToExcel(excelData, `Все заказы на возврат с товарами.xlsx`)
                })
            })
    }

    approve(id,data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/ApproveReturnOrder/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    decline(id, data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/DeclineReturnOrder/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    cancelDecline(id, data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/CancelDeclineReturnOrder/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    stopOrder(id, data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/StopReturnOrder/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    resumeOrder(id, data) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.put(`${APIHOST}/api/ResumeReturnOrder/${id}`, data, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        });
    }

    orderProtocol(id) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));
        return axios.get(`${APIHOST}/api/ReturnOrderProtocolInfo/${id}`, {
            headers: {'Authorization': `Bearer ${oAuthAccess.access_token}`}
        })
    }
}

export default new ReturnOrderService();
